(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ve-toast"] && !Shopify.designMode) return;
  try {
    (function () {
    var box = document.querySelector('[data-ve-toast]');
    if (!box) return;
    var items = box.querySelectorAll('.ve-toast__item');
    var KEY = 've-toast-closed';
    function closed() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
    if (!items.length || closed()) return;
    var i = 0, timer;
    function show() {
      items.forEach(function (el, n) { el.hidden = n !== i; });
      box.hidden = false;
      timer = setTimeout(next, 9000);
    }
    function next() {
      i += 1;
      if (i >= items.length) { box.hidden = true; return; }
      show();
    }
    box.querySelector('.ve-toast__close').addEventListener('click', function () {
      clearTimeout(timer);
      box.hidden = true;
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    });
    box.addEventListener('mouseenter', function () { clearTimeout(timer); });
    box.addEventListener('mouseleave', function () { if (!box.hidden) timer = setTimeout(next, 4000); });
    setTimeout(show, 6000);
  })();
  } catch(e) { console.error(e); }
})();

})();
